import { createAsyncThunk } from "@reduxjs/toolkit";
import { getIntangibleAssetBalanceApi } from "../../../apiservice/reports";



export const fetchIntangibleAssetBalance = createAsyncThunk(
  "intangibleAssetBalance/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters.type === "Intangible Asset Account Wise" ? filters.accId : null,
        fromDate: filters.type === "Date Wise" ? filters.fromDate : null,
        toDate: filters.type === "Date Wise" ? filters.toDate : null,
      };
      const res = await getIntangibleAssetBalanceApi(payload);
      return {
        list: res.data?.assets || [],
        total_balance: res.data?.total_balance || 0,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);